module.exports = __webpack_public_path__ + "static/media/caret-circle-right.e317e2b7.svg";